if (window.innerWidth < 564) {
    let LastScrollTop = 0;
    // const scrollUP = document.querySelector('.scrollup');
    // const scrollUP = document.querySelector('.btn__info');
    const rootElement = document.documentElement;
    const firstSect = document.querySelector('main > section');
    const menuTop = document.querySelector('.header__top');
    const menuMain = document.querySelector('.header__main');

    function handleScroll() {
        // Do something on scroll
        const scrollTop = window.pageYOffset || rootElement.scrollTop;
        if (scrollTop > LastScrollTop) {
            menuTop.classList.add('hiding');
            menuMain.classList.add('hiding');
            // scrollUP.style.opacity = '1';
            // scrollUP.classList.remove('hiding');
        } else if (scrollTop <= 0) {
            // scrollUP.style.opacity = '0';
            menuTop.classList.remove('hiding');
            menuMain.classList.remove('hiding');
            // scrollUP.classList.add('hiding');
        } else {
            menuTop.classList.remove('hiding');
            menuMain.classList.remove('hiding');
        }
        LastScrollTop = scrollTop;
    }

    function scrollToTop() {
        // Scroll to top logic
        rootElement.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }
    // scrollUP.addEventListener('click', scrollToTop);
    document.addEventListener('scroll', handleScroll);
}

if (window.innerWidth > 1200) {
    let LastScrollTop = 0;
    // const scrollUP = document.querySelector('.scrollup');
    // const scrollUP = document.querySelector('.btn__info');
    const rootElement = document.documentElement;
    const firstSect = document.querySelector('main > section');
    const menuTop = document.querySelector('.header__top');
    const menuMain = document.querySelector('.header__main');

    function handleScroll() {
        // Do something on scroll
        const scrollTop = window.pageYOffset || rootElement.scrollTop;
        if (scrollTop > LastScrollTop) {
            menuTop.classList.add('hiding');
            menuMain.classList.add('up');
            // scrollUP.style.opacity = '1';
            // scrollUP.classList.remove('hiding');
        } else if (scrollTop <= 0) {
            // scrollUP.style.opacity = '0';
            menuTop.classList.remove('hiding');
            menuMain.classList.remove('up');
            // scrollUP.classList.add('hiding');
        } else {
            menuTop.classList.remove('hiding');
            menuMain.classList.remove('up');
        }
        LastScrollTop = scrollTop;
    }

    function scrollToTop() {
        // Scroll to top logic
        rootElement.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }
    // scrollUP.addEventListener('click', scrollToTop);
    document.addEventListener('scroll', handleScroll);
}
